// extracted by mini-css-extract-plugin
export default {"wrapper":"shippingOptions_wrapper__5eS5A","title":"shippingOptions_title__be20H","option":"shippingOptions_option__vNNYL","optionInner":"shippingOptions_optionInner__ms3Z8"};